import {NotificationItem} from './notification-item';
import {pdsI18n} from '../pds-i18n';

const MS_IN_DAY = 86400000;

let idx = 0;
export class NotificationItemGroup {

  id: string;

  notifications: Array<NotificationItem> = [];

  unreadNotificationCount = 0;

  unseenNotificationCount = 0;

  title: string;

  tooltip: string | null;

  subtitle: string | null;

  colorClass: string | null;

  mostRecentPostedAt: Date | null;

  postedAtUXFormat: string | null;

  senderUid: string | null;

  requiresAction: boolean;

  userType: string | null;

  static compare(grp1: NotificationItemGroup, grp2: NotificationItemGroup): number {
    if (grp1.mostRecentPostedAt != null && grp2.mostRecentPostedAt == null) {
      return -1;
    } else if (grp1.mostRecentPostedAt == null && grp2.mostRecentPostedAt != null) {
      return 1;
    } else if (grp1.mostRecentPostedAt == null && grp2.mostRecentPostedAt == null) {
      return 0;
    } else {
      // TS isn't picking up on semantics that these properties aren't null so using, '!'
      return  grp2.mostRecentPostedAt!.getTime() - grp1.mostRecentPostedAt!.getTime();
    }
  }

  constructor(public type: string, public aggregationKey: string, public isMarkedReadOnClick, public isRead = true, public isSeen = true) {
    this.id = String(idx++);
  }

  addNotification(notification: NotificationItem): void {
    let title = notification.getTitle();
    if (this.notifications.length === 0) {
      this.title = title;
    } else if (this.title != null && this.title.indexOf(title) === -1) {
      this.title += ', ' + title;
    }

    let toolTipText = notification.getTooltip();
    if (this.tooltip == null) {
      this.tooltip = toolTipText;
    }

    let subtitle = notification.getSubtitle();
    if (!this.subtitle) {
      this.subtitle = subtitle;
    }

    let userType = notification.getUserType();
    if (!this.userType) {
      this.userType = userType;
    }

    if (this.senderUid == null) {
      this.senderUid = notification.getSenderUid();
    }

    let postedAt: Date | null = notification.getPostedAt();
    if (postedAt != null && (this.mostRecentPostedAt == null || (postedAt.getTime() > this.mostRecentPostedAt.getTime()))) {
      this.senderUid = notification.getSenderUid();
      this.mostRecentPostedAt = postedAt;
      this.tooltip = toolTipText;

      this.postedAtUXFormat = pdsI18n.formatDate(postedAt, 'DATE_TIME_PRETTY');
    }

    this.notifications.push(notification);

    if (!notification.isSeen) {
      this.isSeen = false;
      this.unseenNotificationCount++;
    }

    if (!notification.isRead) {
      this.isRead = false;
      this.unreadNotificationCount++;
    }

    if (!this.colorClass) {
      this.colorClass = notification.getColorClass();
    }

    //if any notification needs attention, the whole group does
    this.requiresAction = this.requiresAction || notification.getRequiresAction();
  }

  markAsSeen(): void {
    for (let notification of this.notifications) {
      notification.isSeen = true;
    }
    this.unseenNotificationCount = 0;
    this.isSeen = true;
  }

  markAsRead(): void {
    for (let notification of this.notifications) {
      notification.isRead = true;
    }
    this.unreadNotificationCount = 0;
    this.isRead = true;
  }

  getUnreadNotifications(): Array<NotificationItem> {
    return this.notifications.filter(notification => !notification.isRead);
  }

  get lookUpKey(): string {
    if (this.notifications.length > 0) {
      return this.notifications[0].lookUpKey;
    }
    return '';
  }

  markReadWhere(lookUpFunction: (item: NotificationItem) => boolean): Array<NotificationItem> {
    let notificationsToMark: Array<NotificationItem> = this.notifications.filter(lookUpFunction);
    for (let notification of notificationsToMark) {
      notification.isRead = true;
      this.unreadNotificationCount -= 1;
    }
    return notificationsToMark;
  }
}
